export default __webpack_public_path__ + "static/media/1003.7684b38a.png";